<script>
export default {
    name: "settings",
    data() {
        return {
            menu: [
                {
                    name: 'Profile Settings',
                    path: 'profile',
                },
                {
                    name: 'Reset Password',
                    path: 'resetPassword'
                }
            ]
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="settings">
        <div class="menu flex">
            <router-link class="item" v-for="(item, index) in menu" :key="index" :to="item.path">{{ item.name }}</router-link>
        </div>
        <router-view></router-view>
    </div>
</template>

<style scoped lang="scss">
.menu{
    font-size: .16rem;
    border-bottom: 1px solid #c9c9c9;
    gap: .3rem;
    margin-bottom: .2rem;
    .item{
        display: block;
        line-height: 2;
        &.active{
            border-bottom: 1px solid var(--background-color);
        }
    }
}
</style>